export default "__VITE_ASSET__B$CRc43O__"